export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_en-aa69b08b14123e4d841629eb8c1c3a96.png";